import { getPropertyId } from "common/"
export const APP = '/:propertyId',
  CREATE_EVENT = APP + '/event',
  EDIT_EVENT = APP + '/event/:id/:step?',
  PREVIEW = 'preview',
  PUBLISH = 'publish',
  REPORTS_OVERVIEW = APP + '/reports-overview',
  REPORTS_PROPERTIES = APP + '/reports-properties',
  REPORTS_EVENTS = APP + '/reports-events',
  REPORTS_INVITEES = APP + '/reports-invitees',
  SCHEDULE = 'schedule/:step?',
  APPROVALS = APP + '/approvals/:step?',
  SETTINGS = APP + '/settings/:step?';

export const getAppPath = (propertyId) => {
  return APP.replace(':propertyId', propertyId || getPropertyId());
}

export const getCreateEventPath = (propertyId) => {
  return CREATE_EVENT.replace(':propertyId', propertyId || getPropertyId());
}

export const getEditEventPath = (event, preview) => {
  let id = event.id;
  let path = EDIT_EVENT.replace(':id', id);
  path = path.replace(':propertyId', getPropertyId());

  if (preview) return path.replace(':step?', PREVIEW)

  switch (event.status) {
    case 'published':
      return path.replace(':step?', SCHEDULE)
    case 'publish_scheduled':
      return path.replace(':step?', PUBLISH)
    default: return path.replace(':step?', "");
  }
}

export const getEventEditPath = (event) => {
  let path = EDIT_EVENT.replace(':id', event.id);
  path = path.replace(':propertyId', getPropertyId());
  return path.replace(':step?', "");
};

export const getPublishPath = (event) => {
  let path = EDIT_EVENT.replace(':id', event.id);
  path = path.replace(':propertyId', getPropertyId());
  return path.replace(':step?', PUBLISH);
};

export const getScheduleInvitePath = (event) => {
  let path = EDIT_EVENT.replace(':id', event.id);
  path = path.replace(':propertyId', getPropertyId());
  return path.replace(':step?', SCHEDULE);
};

export const getQueryParams = () => {
  let params = {}
  window.location.search.substr(1).split("&").forEach(key_value => {
    if (key_value.split("=")[0] === "properties")
      params[key_value.split("=")[0]] = key_value.substr(11)
    else
      params[key_value.split("=")[0]] = key_value.split("=")[1] ? key_value.split("=")[1].replace(/%20/g, " ").trim() : ""
  })
  return params;
}

export const getEventRoutesParameters = () => {
  const route = window.location.pathname.split("/").filter(i => i);
  const id = route[2];
  const step = route[3];
  return { id, step }
}

export const getPreviewUrl = (id) => {
  return `https://${process.env.REACT_APP_MyhylyDomain}/mktg/hyevents/${id}/landing_page?hyevent_preview=true`
}

export const getUpcomingEventUrl = () => {
  return `https://${process.env.REACT_APP_MyhylyDomain}/mktg/tenants/${getPropertyId()}/upcoming_events`
}

export const getUpcomingEventCode = () => {
  return `<iframe src="https://${process.env.REACT_APP_MyhylyDomain}/mktg/tenants/${getPropertyId()}/upcoming_events" style="width:100%;height:100vh;"/>`
}